import Attribution from "./Components/Attribution";
import Advice from "./Components/Advice";

function App() {


  
// const dice = document.querySelector("#dice");
// const id = document.querySelector("#adviceId");
// const advice = document.querySelector("#adviceBody");

// function loadQuote() {
//   fetch("https://api.adviceslip.com/advice")
//     .then((response) => {
//       return response.json();
//     })
//     .then((response) => {
//       id.innerHTML = `Advice #${response.slip.id}`;
//       advice.innerHTML = `&#8220${response.slip.advice}&#8221`;
//     });
// }

// dice.addEventListener("click", loadQuote);
  return (
    <div className="App">
      <Advice />
      <Attribution />
    </div>
  );
}

export default App;
